<template>
  <div>
    <div id="app">
      <OfflineBanner :isVisible="!isOnline"></OfflineBanner>
      <ServiceUnavailableView v-if="isServiceUnavailable"/>
      <router-view v-else />
    </div>
    <!-- <FacebookChatBot/> -->
  </div>
</template>

<script>
// import FacebookChatBot from '@/components/FacebookChatBot.vue';
import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import ServiceUnavailableView from '@/views/ServiceUnavailable.vue';
import OfflineBanner from './components/OfflineBanner/OfflineBanner.vue';

export default {
  components: {
    ServiceUnavailableView,
    OfflineBanner,
    // FacebookChatBot,
  },
  data() {
    return {
      isServiceUnavailable: false,
      isOnline: navigator.onLine,
    };
  },
  methods: {
    getCookie(cname) {
      const name = `${cname}=`;
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return '';
    },
    removeCookies(cname) {
      if (cname.length) {
        cname.forEach((item) => {
          document.cookie = `${item.name}=; Path=${item.path}; Domain=${item.domain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        });
      } else {
        document.cookie = `${cname.name}=; Path=${cname.path}; Domain=${cname.domain}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
      }
    },
    handleCookies() {
      if (this.getCookie('analytical') === 'true' && this.getCookie('advertising') === 'true') {
        if (!this.$gtm.enabled()) {
          this.$gtm.enable(true);
        }
      } else {
        const cookiesToRemove = [
          { name: '_ga_52PM4B9S9B', path: '/', domain: '.earlystage.pl' },
          { name: '_ga', path: '/', domain: '.earlystage.pl' },
          { name: '_fbp', path: '/', domain: '.earlystage.pl' },
        ];
        this.removeCookies(cookiesToRemove);
      }
      if (this.getCookie('functional') === 'true') {
        if (process.env.VUE_APP_ENVIRONMENT !== 'localhost') {
          const ignoreErrors = [
            'timeout of 0ms exceeded',
            'ResizeObserver loop limit exceeded',
            /Li is not a constructor/gm,
            /oi is not a constructor/gm,
            /n.manager/gm,
            /_avast_submit/gm,
            /lesson/gm,
            /t0.response.status/gm,
            /Unexpected token/gm,
            /window.webkit.messageHandlers/gm,
            'Unexpected identifier',
            'e[t] is not a function',
            'e.t0.response is undefined',
            /expected expression, got/gm,
            /Loading CSS chunk/gm,
            /Loading chunk/gm,
            /e.toLowerCase/gm,
            /Request failed/gm,
            'Network Error',
            'Request aborted',
            'e is undefined',
            'Unexpected end of JSON input',
            /navigation/gm,
            /undefined is not an object/gm,
            /null is not an object/gm,
            /getRestrictions is not a function/gm,
            /Cannot read properties of undefined/gm,
            /Failed to fetch/gm,
            /Event is not a constructor/gm,
            /Load failed/gm,
            /f is undefined/gm,
            /ResizeObserver loop completed with undelivered notifications/gm,
          ];
          Sentry.init({
            Vue,
            release: 'es-online',
            environment: process.env.VUE_APP_ENVIRONMENT,
            dsn: process.env.VUE_APP_SENTRY_KEY,
            integrations: [new Integrations.BrowserTracing()],
            tracesSampleRate: 0.1,
            ignoreErrors,
            beforeSend(event) {
              if (
                event
                && event.message
                && ignoreErrors.find(
                  item => item === event.message || (item instanceof RegExp && item.test(event.message)),
                )
              ) {
                return null;
              }
              if (
                event
                && event.exception?.values?.[0]?.stacktrace?.frames?.some(f => f.filename?.includes('https://www.googletagmanager.com/'))
              ) {
                return null;
              }
              return event;
            },
          });
        }
      }
    },
  },
  created() {
    this.handleCookies();
    if (parseInt(localStorage.getItem('access-token'), 10) === 1) {
      this.isServiceUnavailable = false;
    }
  },
  updated() {
    this.handleCookies();
  },
  mounted() {
    window.addEventListener('online', () => { this.isOnline = true; });
    window.addEventListener('offline', () => { this.isOnline = false; });
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/app.scss";

[v-cloak] {
  display: none;
}
</style>
